import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query';
import { APIResponse, QueryReturnValue } from '~/api/baseFetch/common.type';

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_ONEPASS_API_DOMAIN,
  method: 'POST',
});

export const onePassFetchBase: BaseQueryFn = async (
  args: string | FetchArgs,
  api,
  extraOptions,
) => {
  const result = (await baseQuery(args, api, extraOptions)) as QueryReturnValue<
    APIResponse<unknown>,
    FetchBaseQueryError,
    FetchBaseQueryMeta
  >;
  return result;
};
